import { useState, useEffect } from 'react';
import { IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonModal, IonButtons, IonBackButton, IonCardContent, IonTextarea, IonItemGroup, IonItemDivider, IonItem, IonLabel, IonSearchbar, IonSelect, IonSelectOption, IonToast, IonIcon } from '@ionic/react';
import { base64FromPath } from '@ionic/react-hooks/filesystem';
import {config} from '../Constants';
import CryptoJS from 'crypto-js';
import md5 from 'crypto-js/md5';
import { camera, cameraOutline, trashOutline, arrowDown, arrowUp } from 'ionicons/icons';
import React from 'react';
import { Camera } from '@capacitor/camera';
import AnimateHeight from 'react-animate-height';
import {sendErrorMsg} from '../components/DiscordHookError';
import {getAnalytics, logEvent} from 'firebase/analytics';
import { initializeApp } from "firebase/app";


import trailerId from "../imgs/test_trailer_1.jpg";
import { ApiService } from '../api/ApiService';
import { toastStore } from '../components/AppToast';
import TrailerPhotoIdFirstIn from '../components/walkthrough/individualPage/TrailerPhotoIdFirstIn';




const timages: any[] = [];

interface Photo {
    filepath: string;
    webviewPath?: string;
    data: any;
}


//if this doesn't get used, delete it
var c = document.getElementById("canv")

let hashArray: any = [];

const TrailerIdPhotos: React.FC<{moduleHistory: string}> = ({ moduleHistory }) => {

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successPhoto, setSuccess] = useState(false);
    const [toast, setToast] = useState<string>("")
    const [photoMsg, setPhotoMsg] = useState<string>("Take photo");
    const [images, setImages] = useState<Photo[]>([]);
    const [trailerReport, setTrailerReport] = useState<string>("");
    const [unitNumber, setUnitNumber] = useState("");
    const [height1, setHeight1] = useState(false);



    useEffect(() => {
        // get the unit # from userProfile
        var data = new FormData()
        data.append("payload", JSON.stringify({ cmds: [{cmd: "driverProfile", args: {ownerCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token')}}] }))
        const requestOptions = {
            method: 'POST',
            headers: {},
            body: data
        };

        console.log(requestOptions)
        //debug log ^^
        fetch(config.url.BASE_URL, requestOptions).then(response => response.json())
        .then(json => 
        {
            if (json.results[0].errcode === 'NOTLOGGEDIN')
                 {localStorage.removeItem('token')}
            else if (json.results[0].errmsg){
                console.error("Error: ", json.results[0].errmsg);
            }
                else {
                    setUnitNumber(json.results[0].unit)
                }
        })


        //getting the load #
    }, [])




    //tool functions
    async function removeHashes(removalArray: any) {
        removalArray.forEach(async (element: any) => {
          await ApiService.photoChecksumRevoke("tarpPhotos", {checksum: element}).then(it => {
            hashArray = hashArray.filter((hash: any) => hash !== element)
          })
        });
      }





    enum CameraResultType {
        Uri = 'uri',
        Base64 = 'base64',
        DataUrl = 'dataUrl'
    }

    const b64toBlob = (base64: any) => fetch(base64).then(res => res.blob())

    async function submitTrailerIdPhotos(){
        setLoading(true)
        var data = new FormData();
        data.append("payload", JSON.stringify({ cmds: [{cmd: "trailerIdUpload", args: {loginToken: localStorage.getItem('token'), unitId: unitNumber}}]}))
        for(let i = 0; i < images.length; i++){
            data.append(`photo`, new Blob([(await b64toBlob(images[i].data))],{type: 'application/octet-stream'}));
        }
        const requestOptions = {
            method: 'POST',
            body: data
          };
          fetch(config.url.BASE_URL, requestOptions)
          .then(response => response.json())
          .then(json => {if(json.results[0].errmsg){setShowErrorModal(true);
            removeHashes(hashArray); setLoading(false);}else{setLoading(false);
            setSuccess(true); console.log("photos successful", json.results[0]);
            setTrailerReport(JSON.stringify(json.results[0]));}})
        
    }
    async function takePicture() {
        const image = await Camera.getPhoto({
          quality: 30,
          allowEditing: false,
          resultType: CameraResultType.Uri
        });
        const fileName = new Date().getTime() + '.jpeg';
        // await addDateTime(image.webPath!)
        const base64Data = await base64FromPath(image.webPath!);
        console.log("data");
        const newPhotos = [{
          filepath: fileName,
          webviewPath: image.webPath, 
          data: base64Data
        }, ...images];
        setImages(newPhotos)
        timages.push(image)
        if (timages.length > 0) {
          setPhotoMsg("Take another photo")
        }
        console.log("hashArray", hashArray);
    }

    const removePhoto = (e: any) => {
        console.log("hashArasyaya", hashArray);
        const name = e.filepath;
        var hash = CryptoJS.MD5(e.data).toString();
        console.log("test remove", hash, hashArray);
        hashArray.forEach(async (element: any) => {
          console.log("hashArray removal", hash, element);
          if (hash === element) {
            await removeHashes([element])
            hashArray = hashArray.filter((hash: any) => hash !== element)
          }
        });
        setImages(images.filter(image => image.filepath !== name));
      }

      return (
        <TrailerPhotoIdFirstIn>
        <IonPage>
        <IonHeader>
            <IonToolbar color="primary">
            <IonButtons slot="start">
                <IonBackButton defaultHref="/Trip"  text=""/>
              </IonButtons>
              <IonTitle>Trailer Plate Photos</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonToast
            isOpen={showToast}
            onDidDismiss={() => setShowToast(false)}
            message={toast}
            color="danger"
            duration={5000}
          />
           <IonModal isOpen={loading} id="transparent">
            <div className="modal-div">
              <div id="modal">
                <div className='loading-div'>
                  <p>Please wait... your photo is being submitted.</p>
                  <div className="snippet" data-title=".dot-flashing" style={{ margin: "4px 16px"}}>
                    <div className="stage">
                      <div className="dot-flashing"></div>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </IonModal>
          <IonToast
            isOpen={successPhoto}
            onDidDismiss={() => {setLoading(false); setSuccess(false)}}
            message="Your photo was submitted."
            color="success"
            duration={3000}
          />
           <IonToast
            isOpen={showErrorModal}
            message="Error! Your photo could not be uploaded, check your connection and please try again."
            color="danger"
            duration={5000}
          />
          <IonContent color='white'>
              <div className='main-2'>
                <div>
                  <IonItem color="white" lines="none">
                    <div className='item-container'>
                      <h1>Submit Trailer Plate Photo</h1>
                      <p style={{fontSize: "medium"}}><b>Please submit a photo of the trailer with the plate clearly visible: </b><br/>(Example below)</p><br/>
                  
                      <div id="rearSideFrontSection">
                        <div style={{ textAlign: "center"}} onClick={ e => {setHeight1(!height1); console.log("expanded");}} aria-expanded={ height1 !== false }>
                          <div className='western-button-link'>
                              <div id="current-load-button"  style={{background: "#e9e9e9"}} >
                                  <p style={{paddingLeft: "15px"}}><b>Front</b> view with trailer plate included</p>
                                  <img src={height1 == true ? arrowUp : arrowDown} style={{ height: "2vh", paddingRight: "15px"}} alt="arrow"/>
                              </div>
                          </div>
                        </div>
                        <AnimateHeight style={ height1 === true ? {overflowY: 'scroll', borderRadius: "10px", textAlign: "center" } : { overflowY: 'scroll'}} duration={500} height={ height1 === true ? 'auto' : 0 } id="loadSection">
                          <img src={trailerId} alt="Front Trailer Image" style={{borderRadius: "8px", textAlign: "center"}}/>
                        </AnimateHeight>
                      </div>
                    </div>
                  </IonItem>
                </div>
    
                <div>
                  <div style={{ display: "grid", gridTemplateColumns: '1fr', padding: "8px", backgroundColor: "#ffffff", margin: "auto", textAlign: "center"}} >
                    {images.map(function(img, index) {
                      return <div key={index} onClick={e => {removePhoto(img)}} style={{position: "relative"}}>
                        <img alt="tarppay img"  style={{width: "200px", borderRadius: "10px"}}src={img.webviewPath} />
                        <button style={{ backgroundColor: "rgba(0,0,0,0)", borderRadius: "50%", width: "42px", height: "42px", position: "absolute", top: "0", left: "0"}}><IonIcon style={{color: "#ff0000", fontSize: "xx-large"}} icon={trashOutline}></IonIcon></button>
                      </div>
                    })}
                  </div>
                </div>
              </div>
    
              <div id= "TarpPayBottom">
                {images.length < 1 ? <button className='button' style={{margin: "18px auto"}} onClick={e => {takePicture()}}><p>Take Photo</p><IonIcon icon={cameraOutline}></IonIcon></button> : null}
    
                {/* <textarea style={{width: "100%", height: "100px", borderRadius: "10px", padding: "10px", margin: "10px 0"}} placeholder="Trailer Id Info" value={trailerReport} disabled={true}/> */}
    
                <IonItem lines="none" color="white">
                  <div className='item-container'>
                    <button className="western-button submit" disabled={images.length < 1}  onClick={e => {submitTrailerIdPhotos()}}>SUBMIT TRAILER PHOTO</button>
                  </div>
                </IonItem>
              </div>
          </IonContent>
     
        </IonPage>
        </TrailerPhotoIdFirstIn>
      );
    };
    
    export default TrailerIdPhotos;


